import React from "react";
import {connect} from "react-redux";
import { Switch, Route } from "react-router-dom";


import CreateEdit from 'views/AdjustmentsReason/CreateEdit'
import Form from 'views/AdjustmentsReason/Form'
import List from 'views/AdjustmentsReason/List'


class AdjustmentsReason extends React.Component {
  render() {
    const {match}=this.props;
    return (
          <Switch>
            <Route path={`${match.path}/add`} component={CreateEdit}/>
            <Route path={`${match.path}/:id`} component={Form}/>
            <Route component={List}/>
          </Switch>
    );
  }
}
const state=(state)=>({})
const dispatch=(dispatch)=>({})
export default connect(state,dispatch)(AdjustmentsReason);



// WEBPACK FOOTER //
// ./src/views/AdjustmentsReason/AdjustmentsReason.jsx